import React, { Component } from 'react';
import { JqueryClassFaker } from '../../components/JqueryClassFaker';

export default class ExpandingTextarea extends Component {
	constructor(props) {
		super(props);
		this.reference = React.createRef();
		this.autoExpand = this.autoExpand.bind(this);
		this.autoExpand = _.throttle(this.autoExpand, 200);

		this.setRef = this.setRef.bind(this);
	}

	setRef(ref) {
		const { setRef } = this.props;
		if(setRef) {
			setRef(ref);
		}
		this.reference = ref;
	}

	componentDidMount() {
		const { autoFocus } = this.props;
		const tag = this.reference;
		if(!tag) {
			return;
		}

		if(autoFocus) {
			tag.selectionStart = tag.value.length;
			tag.selectionEnd = tag.value.length;
		}

		tag.addEventListener('paste', this.autoExpand);
		tag.addEventListener('input', this.autoExpand);
		tag.addEventListener('keyup', this.autoExpand);
		this.autoExpand();
	}

	autoExpand() {
		const element = this.reference;
		if(this.reference) {
			element.style.height = 'inherit';
			element.style.height = element.scrollHeight + 'px';
		}
	}

	render() {
		const { setRef, ...props } = this.props;

		return (
			<textarea
				ref={this.setRef}
				{...props}
			/>
		);
	}

}